import React from 'react';
var defaultContext =
/*#__PURE__*/
React.createContext(undefined); // We share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext() {
  // @ts-ignore (for global)
  if (typeof global !== 'undefined' || typeof window !== 'undefined') {
    // @ts-ignore (for global)
    var thisContext = global || window;

    if (!thisContext.ReactQueryClientContext) {
      thisContext.ReactQueryClientContext = defaultContext;
    }

    return thisContext.ReactQueryClientContext;
  }

  return defaultContext;
}

export var useQueryClient = function useQueryClient() {
  var queryClient = React.useContext(getQueryClientContext());

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
export var QueryClientProvider = function QueryClientProvider(_ref) {
  var client = _ref.client,
      children = _ref.children;
  React.useEffect(function () {
    client.mount();
    return function () {
      client.unmount();
    };
  }, [client]);
  var Context = getQueryClientContext();
  return (
    /*#__PURE__*/
    React.createElement(Context.Provider, {
      value: client
    }, children)
  );
};